import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * BART — FTUE demo (3 essais).
 *
 * E1 : ballon test maxPumps=8, pédagogie pompe / encaisse
 * E2 : ballon test maxPumps=16, le joueur teste l'incertitude
 * E3 : signal "prêt", skip vers session
 */
import { useState } from 'react';
import { pickExplosionThreshold } from './data';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — Petit ballon',
        hint: 'Pompe pour gagner +1, encaisse avant l\'explosion. Cible : 4 pompes.',
        maxPumps: 8,
    },
    {
        idx: 2,
        title: 'Essai 2 — Ballon moyen',
        hint: 'Le seuil d\'explosion est aléatoire. Trouve l\'équilibre.',
        maxPumps: 16,
    },
    {
        idx: 3,
        title: 'Essai 3 — prêt',
        hint: 'Le round normal compte 6-10 ballons selon ton niveau.',
        maxPumps: 12,
    },
];
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const [pumps, setPumps] = useState(0);
    const [outcome, setOutcome] = useState('idle');
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const threshold = pickExplosionThreshold(step.maxPumps, step.idx);
    const handlePump = () => {
        if (outcome !== 'idle')
            return;
        const next = pumps + 1;
        setPumps(next);
        if (next >= threshold) {
            setOutcome('popped');
        }
    };
    const handleBank = () => {
        if (outcome !== 'idle')
            return;
        setOutcome('banked');
    };
    const handleNext = () => {
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
        setPumps(0);
        setOutcome('idle');
    };
    const balloonRadius = Math.min(110, 24 + (pumps / step.maxPumps) * 80);
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsx("div", { className: "flex h-[240px] w-full items-center justify-center", children: _jsx("svg", { width: 240, height: 240, viewBox: "0 0 240 240", children: _jsx("circle", { cx: 120, cy: 120, r: balloonRadius, fill: "#1c5f9e", opacity: 0.85 }) }) }), _jsxs("p", { className: "font-mono text-[10px] uppercase tracking-[0.20em] text-cyan-text-faint", children: ["Pompes : ", pumps] }), outcome === 'idle' && (_jsxs("div", { className: "flex w-full max-w-[320px] gap-s3", children: [_jsx("button", { type: "button", onClick: handlePump, className: "inline-flex h-12 flex-1 items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: "Pomper" }), _jsx("button", { type: "button", onClick: handleBank, className: "inline-flex h-12 flex-1 items-center justify-center border border-cyan-border bg-cyan-surface font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-text transition active:scale-[0.985] hover:bg-cyan-bg", children: "Encaisser" })] })), outcome !== 'idle' && (_jsx("span", { className: [
                    'font-display text-[28px] font-medium',
                    outcome === 'banked' ? 'text-cyan-core' : 'text-cyan-media',
                ].join(' '), children: outcome === 'banked' ? `✓ +${pumps}` : '✗ Boom' })), _jsxs("div", { className: "mt-auto flex flex-col items-stretch gap-s3 self-stretch", children: [outcome !== 'idle' && (_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' })), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map